import React from 'react';
import { Link } from 'react-router-dom';

const QuizResult = ({ score, totalQuestions, userAnswers, questions, category, difficulty, onRestart }) => {
  // Calculer le pourcentage de réussite
  const percentage = Math.round((score / totalQuestions) * 100);
  
  // Déterminer le feedback en fonction du score
  const getFeedback = () => {
    if (percentage >= 80) {
      return {
        class: 'feedback-excellent',
        title: 'Excellent !',
        message: `Bravo ! Vous êtes un véritable expert sur le sujet ${category.name}. Votre connaissance approfondie impressionne même les cardinaux !`
      };
    } else if (percentage >= 60) {
      return {
        class: 'feedback-good',
        title: 'Bien joué !',
        message: `Vous avez de bonnes connaissances sur ${category.name}. Encore un peu d'étude et vous pourriez conseiller le prochain conclave !`
      };
    } else if (percentage >= 40) {
      return {
        class: 'feedback-average',
        title: 'Pas mal !',
        message: `Vous avez des connaissances de base sur ${category.name}. Continuez à explorer notre site pour en apprendre davantage !`
      };
    } else {
      return {
        class: 'feedback-poor',
        title: 'Vous pouvez faire mieux !',
        message: `Il semble que ${category.name} ne soit pas (encore) votre domaine de prédilection. Explorez notre site pour devenir incollable sur le conclave !`
      };
    }
  };
  
  const feedback = getFeedback();
  
  return (
    <div className="quiz-result">
      <div className="result-header">
        <h2>Résultats du Quiz</h2>
        <div className="score-display">{score}/{totalQuestions}</div>
        <p className="score-text">Vous avez obtenu {percentage}% de bonnes réponses</p>
        
        <div className={`result-feedback ${feedback.class}`}>
          <h3>{feedback.title}</h3>
          <p>{feedback.message}</p>
        </div>
      </div>
      
      <div className="result-actions">
        <button className="restart-button" onClick={onRestart}>
          Recommencer
        </button>
        <Link to="/cardinaux" className="back-button">
          Explorer l'annuaire des cardinaux
        </Link>
      </div>
      
      <div className="answers-review">
        <h3>Revue des questions</h3>
        
        {questions.map((question, index) => {
          const userAnswer = userAnswers[index];
          const isCorrect = userAnswer?.isCorrect || false;
          const isTimeout = userAnswer?.userAnswer === -1;
          
          return (
            <div key={question.id} className="answer-item">
              <h4>Question {index + 1}: {question.question}</h4>
              
              {isTimeout ? (
                <div className="user-answer timeout">
                  <div className="answer-icon">⏱️</div>
                  <div>Temps écoulé - Vous n'avez pas répondu à temps</div>
                </div>
              ) : (
                <div className={`user-answer ${isCorrect ? 'correct' : 'incorrect'}`}>
                  <div className="answer-icon">{isCorrect ? '✅' : '❌'}</div>
                  <div>
                    <div>Votre réponse: {question.options[userAnswer?.userAnswer]}</div>
                    {!isCorrect && (
                      <div>Réponse correcte: {question.options[question.correctAnswer]}</div>
                    )}
                  </div>
                </div>
              )}
              
              <div className="answer-explanation">
                <h5>Explication:</h5>
                <p>{question.explanation}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuizResult;